/**
 * @fileoverview added by tsickle
 * Generated from: models/customer.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { model } from '../util/model';
/** @enum {string} */
var CustomerContactCategory = {
    Ratings: "ratings",
    Invoices: "receipts",
    Marketing: "marketing",
};
export { CustomerContactCategory };
/**
 * A customer contact category.
 * @record
 */
function CustomerContactPreference() { }
if (false) {
    /** @type {?} */
    CustomerContactPreference.prototype.key;
    /** @type {?|undefined} */
    CustomerContactPreference.prototype.label;
    /** @type {?} */
    CustomerContactPreference.prototype.value;
}
/**
 * Represents a customer's contact preferences.
 * @record
 */
export function CustomerNotifications() { }
if (false) {
    /** @type {?} */
    CustomerNotifications.prototype.contactCategories;
}
/**
 * Base model for a customer, containing all relevant fields returned by the API.
 * @record
 */
function BaseCustomerModel() { }
if (false) {
    /** @type {?} */
    BaseCustomerModel.prototype.accountId;
    /** @type {?} */
    BaseCustomerModel.prototype.dateOfBirth;
    /** @type {?} */
    BaseCustomerModel.prototype.email;
    /** @type {?} */
    BaseCustomerModel.prototype.gender;
    /** @type {?} */
    BaseCustomerModel.prototype.hasActiveDevice;
    /** @type {?} */
    BaseCustomerModel.prototype.hasClickedAppStoreReviewCta;
    /** @type {?} */
    BaseCustomerModel.prototype.hasClickedGoogleReviewCta;
    /** @type {?} */
    BaseCustomerModel.prototype.hasPassword;
    /** @type {?} */
    BaseCustomerModel.prototype.managedPropertyId;
    /** @type {?} */
    BaseCustomerModel.prototype.name;
    /** @type {?|undefined} */
    BaseCustomerModel.prototype.paymentCardExpiryMonth;
    /** @type {?|undefined} */
    BaseCustomerModel.prototype.paymentCardExpiryYear;
    /** @type {?|undefined} */
    BaseCustomerModel.prototype.paymentCardLast4;
    /** @type {?|undefined} */
    BaseCustomerModel.prototype.paymentCardType;
    /** @type {?} */
    BaseCustomerModel.prototype.preferredName;
    /** @type {?|undefined} */
    BaseCustomerModel.prototype.primaryTelephoneNumber;
    /** @type {?|undefined} */
    BaseCustomerModel.prototype.secondaryTelephoneNumber;
    /** @type {?} */
    BaseCustomerModel.prototype.stripeCustomerId;
    /** @type {?|undefined} */
    BaseCustomerModel.prototype.stripePaymentCardId;
    /** @type {?|undefined} */
    BaseCustomerModel.prototype.stripePaymentMethodId;
    /** @type {?} */
    BaseCustomerModel.prototype.telephoneNumbersForApi;
}
/**
 * Optional expandable fields that can be requested from the API.
 * @record
 */
function CustomerExpandables() { }
if (false) {
    /** @type {?|undefined} */
    CustomerExpandables.prototype.account;
    /** @type {?|undefined} */
    CustomerExpandables.prototype.managedProperty;
    /** @type {?|undefined} */
    CustomerExpandables.prototype.notifications;
}
/**
 * @record
 */
function CustomerModelMixin() { }
if (false) {
    /** @type {?|undefined} */
    CustomerModelMixin.prototype.wantsContactCategory;
}
/**
 * Model representing a customer.
 * @record
 */
export function Customer() { }
/** @type {?} */
export var customer = model.extend((/** @type {?} */ ({
    modelName: 'customer',
    wantsContactCategory: /**
     * @param {?} category
     * @return {?}
     */
    function (category) {
        if (this.notifications) {
            return this.notifications.contactCategories.some((/**
             * @param {?} __0
             * @return {?}
             */
            function (_a) {
                var key = _a.key, value = _a.value;
                return key === category && value;
            }));
        }
        return false;
    }
})));
